var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnMonitorLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2297 28.75L19.8297 30.75H24.1703L23.7703 28.75H20.2297ZM25 27.25H19L18 32.25H26L25 27.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31 13.25H13C12.7239 13.25 12.5 13.4739 12.5 13.75V26.75C12.5 27.0261 12.7239 27.25 13 27.25H31C31.2761 27.25 31.5 27.0261 31.5 26.75V13.75C31.5 13.4739 31.2761 13.25 31 13.25ZM13 11.75C11.8954 11.75 11 12.6454 11 13.75V26.75C11 27.8546 11.8954 28.75 13 28.75H31C32.1046 28.75 33 27.8546 33 26.75V13.75C33 12.6454 32.1046 11.75 31 11.75H13Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 25.5H12V24H32V25.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnMonitorLight);
export default __webpack_public_path__ + "static/media/btn_monitor_light.79cd7d4a3c97b7a417933012c6cf25b4.svg";
export { ForwardRef as ReactComponent };